import React from 'react';
import { MessageCircle } from 'lucide-react';

const WHATSAPP_URL = "https://wa.me/525538164204?text=Hola%2C%20necesito%20soporte%20de%20NOVOPAY";

export const WhatsAppFloat = () => {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Soporte por WhatsApp"
      data-testid="whatsapp-float-button"
      className="fixed bottom-6 right-6 z-[60] group flex items-center"
    >
      <span className="absolute right-16 whitespace-nowrap bg-black/90 text-white text-sm font-medium px-3 py-2 rounded-lg border border-slate-700 opacity-0 translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 pointer-events-none">
        Escríbenos por WhatsApp
      </span>
      <span className="relative flex items-center justify-center h-14 w-14 rounded-full bg-[#25D366] text-white shadow-lg shadow-black/40 hover:bg-[#20bd5a] hover:scale-105 transition-all duration-300">
        <span className="absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-60 animate-ping"></span>
        <MessageCircle className="relative h-7 w-7" />
      </span>
    </a>
  );
};
